import React, { useEffect, useRef, useState } from "react";
import Image from "react-bootstrap/Image";
import LoginLeftBg from "../../assets/img/login-left-bg.jpg";
import KshemaLogo from "../../assets/img/CropWatchLogo.png";
import "./LoginPage.css";
import { Button, Col, Container, Form, Label, Row } from "reactstrap";
import CenterSpinner from "../../components/CenterSpinner";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import {
  setAuthenticated,
  setLocalLogout,
} from "../../redux/slices/loginSlice"
import { LOGIN_STATUS } from "../../utils/Constant";
import { toast } from "react-toastify";
import { UserManager } from "oidc-client-ts";
import oidcConfig, {userManager} from "../../utils/AuthConfig";
import { refreshAuthToken, getAccessedStatesnDistricts } from "../../utils/AuthUtils";
import { useNavigate } from "react-router-dom";
import { getRole, getRolePermission } from "../../utils/RBAC";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { LoggedUserType } from "../../models/GlobalModels";
interface ILoginProps {}

const LoginPage: React.FunctionComponent<ILoginProps> = (
  props: ILoginProps
) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const callLogin = () => {
    userManager.signinRedirect().then(response => {
      console.log('Login initiated', response);    
    }).catch((error) => {
      console.error('Login error:', error);
    });
  };

  const handleCallback = () => {
    userManager.signinRedirectCallback().then(user => {
      onSuccessfulLogin(user);
    }).catch(error => {
      console.error('Callback processing error:', error);
    });
  };
 
  useEffect(() => {
      handleCallback();
  }, []);

  const onSuccessfulLogin = async (payload: any) => {
    const AT = payload.accessToken || payload.access_token;
    const tokenPayload = JSON.parse(atob(AT.split('.')[1]));
    const userGroups = tokenPayload.groups || [];
    const hasICVOPSAccess = userGroups.some((group: string) => 
      group.includes('/Employee Group/Crop-Watch-Ops')
    );
    
    if (!hasICVOPSAccess) {
      toast.error("Access denied. Unauthorized group.");
      dispatch(setLocalLogout({}));
      setTimeout(() => {
        userManager.signoutRedirect().then((res: any) => {
          console.log('signedout successfully', res);
        }).catch((err: any) => {
          console.error('logout failed', err)
        })
      }, 2000);
      return;
    }
    
    const sessionId = tokenPayload.sid || tokenPayload.session_state || "";
    const roleData = getRole(tokenPayload.groups || []);

    const { accessedStates, accessedDistricts, userRole, employeeId } = await getAccessedStatesnDistricts(payload.profile.email, payload.access_token);
    
    const data: LoggedUserType = {
      candidateUniqueId: employeeId,
      employeeName: payload.profile.name,
      emailId: payload.profile.email,
      accessToken: payload.access_token,
      accessExpiryTime: payload.expires_at, 
      resetToken: payload.refresh_token,
      resetExpiryTime: payload.expires_at,
      permissions: getRolePermission(tokenPayload),
      roleId: userRole,
      roleName: roleData.groups,
      sessionId: sessionId,
      userId: tokenPayload?.sub || "",
      accessedStates: accessedStates,
      accessedDistricts: accessedDistricts
    };
  
    toast.success('Logged in successfully');
    dispatch(
      setAuthenticated({
        status: LOGIN_STATUS.AUTHENTICATED,
        user: data,
      })
    );
  };


  return (
    <Container className="p-0 m-0 login-parent">
      <Row className="p-0 m-0">
        <Col md={6} className="p-0 m-0 position-relative">
          <div className="position-relative image-parent-height">
            <Image
              src={LoginLeftBg}
              alt="img"
              className="opacity-52  image-parent w-100"
            />
            <div className="bg-overlay position-absolute top-0 start-0 w-100 image-parent-height" />
            <div className="position-absolute welcome-parent">
              <div className="text-left">
                <Label className="welcome">Welcome to</Label>
                <Label className="fieldAssist mt-n25">CROP WATCH OPS</Label>
              </div>
            </div>
          </div>
        </Col>
        <Col md={6} className="p-3 m-0">
          <div className="m-5 d-flex flex-column align-items-center">
            <Image src={KshemaLogo} alt="img" className="logo"  />
              <Button
                variant="success"
                size="lg"
                className="login-button"
                disabled={showLoader}
                onClick={callLogin}
              >
                Login
              </Button>
          </div>
        </Col>
      </Row>
      <CenterSpinner showLoader={showLoader} />
    </Container>
  );
};

export default LoginPage;
